<template>
  <main class="scripts_main">
    <article @click="this.$parent.addDialog()">
      <h3>Телефонный звонок</h3>
      <img src="./../../assets/images/interface/phone.png" />
    </article>
    <article>
      <h3>Входящее сообщение</h3>
      <img src="./../../assets/images/interface/chat.png" />
    </article>
  </main>
</template>
<style scoped lang="scss" src="./../../assets/styles/scripts/main.scss"></style>
